const tpl = (name) => `USER_RELATIONS/${name}`;

export const GET_RELATIONS = tpl`GET_RELATIONS`;
export const GET_RELATIONS_SUCCESS = tpl`GET_RELATIONS_SUCCESS`;
export const GET_RELATIONS_FAILURE = tpl`GET_RELATIONS_FAILURE`;

export const UPDATE_RELATIONS = tpl`UPDATE_RELATIONS`;
export const UPDATE_RELATIONS_SUCCESS = tpl`UPDATE_RELATIONS_SUCCESS`;
export const UPDATE_RELATIONS_FAILURE = tpl`UPDATE_RELATIONS_FAILURE`;

export const GET_ACTIVE = tpl`GET_ACTIVE`;
export const GET_ACTIVE_SUCCESS = tpl`GET_ACTIVE_SUCCESS`;
export const GET_ACTIVE_FAILURE = tpl`GET_ACTIVE_FAILURE`;
